import React from 'react'
import TerminationFileViewer from '../components/TerminationFileViewer'

const TerminationFilePage = (
  props: Record<string, never> & { routeParams: { importPublicKey: string } }
) => {
  return (
    <div>
      <TerminationFileViewer {...props} routeParams={props.routeParams} />
    </div>
  )
}

export default TerminationFilePage
